import { mapFormBasicInfoTo1091 } from 'legacy/lut/services/partner360/basicInfo/mappings/mapFormBasicInfoTo1091'
import { updatePartnerBasicInfo } from 'legacy/lut/services/partner360/basicInfo/updatePartnerBasicInfo'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { UPDATE_BASIC_INFO_DATA } from '../constants'
import { isBasicInfoCreated } from '../helpers/typeGuards'
import { IFormBasicInfo } from '../models/formBasicInfo'
import { TBasicInfoCreated } from '../models/partnerBasicInfo'
import { selectCreatedBasicInfo } from '../selectors/selectCreatedBasicinfo'

export const updateBasicInfo = createAsyncThunk<TBasicInfoCreated | undefined, IFormBasicInfo>(
  UPDATE_BASIC_INFO_DATA,
  async (formData, { getState }) => {
    const state = getState()

    const { entryId, partnerId, fYear, programType } = selectCreatedBasicInfo(state)

    const mappedData = mapFormBasicInfoTo1091(formData)

    if (!entryId) {
      throw new Error('unable to update basicInfo data')
    }

    const createdData = await updatePartnerBasicInfo({
      ...mappedData,
      EntryId: entryId,
      PartnerId: partnerId,
      FYear: fYear,
      ProgramType: programType,
    })

    return isBasicInfoCreated(createdData) ? createdData : undefined
  }
)
